import React from 'react';

import {TitleProps, TYPES} from './types';
import {
  H1,
  H2,
  H3,
  H4,
} from './style';

const Title = ({type, children}: TitleProps) => {
  switch (type) {
    case TYPES.H2:
      return <H2>{children}</H2>;
    case TYPES.H3:
      return <H3>{children}</H3>;
    case TYPES.H4:
      return <H4>{children}</H4>;
    case TYPES.H1:
    default:
      return <H1>{children}</H1>;
  }
};

export {Title, TYPES};
